module.exports = {"$schema":"http://json-schema.org/draft-04/schema#","title":"address","description":"A Ripple account address","type":"string","format":"address","link":"address","pattern":"^r[1-9A-HJ-NP-Za-km-z]{25,34}$"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ripple-lib/dist/npm/common/schemas/objects/address.json
// module id = xfJ5
// module chunks = 1